import { render } from "./IconStop.vue?vue&type=template&id=7906e676"
import script from "./IconStop.vue?vue&type=script&lang=js"
export * from "./IconStop.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__